import { render, staticRenderFns } from "./ChartBar.vue?vue&type=template&id=f313ff10&scoped=true"
import script from "./ChartBar.vue?vue&type=script&lang=js"
export * from "./ChartBar.vue?vue&type=script&lang=js"
import style0 from "./ChartBar.vue?vue&type=style&index=0&id=f313ff10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f313ff10",
  null
  
)

export default component.exports